import Reveal from "./Reveal";
import LayeredStackDiagram from "./visuals/LayeredStackDiagram";

const NAVY = "#0d0f1e";
const INK = "#f4f4f8";
const BODY = "#b8b9c8";
const MUTED = "#8a8ba0";

const InfrastructureArchitecture = () => {
  return (
    <section
      id="architecture"
      className="scroll-mt-24"
      style={{ backgroundColor: NAVY }}
    >
      <div
        className="relative"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "16px 16px",
        }}
      >
        <div className="container py-24 md:py-32">
          <Reveal>
            <div className="grid grid-cols-1 xl:grid-cols-12 gap-12 lg:gap-16 items-center">
              <div className="xl:col-span-5 max-w-3xl">
                <p
                  className="text-[12px] uppercase tracking-[0.16em]"
                  style={{
                    fontFamily:
                      "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
                    color: MUTED,
                  }}
                >
                  Architecture
                </p>
                <h2
                  className="display mt-5 text-section-title leading-[1.1]"
                  style={{ color: INK }}
                >
                  Integrate once. Expand infinitely.
                </h2>
                <div
                  className="mt-8 space-y-5 text-base md:text-[17px] leading-relaxed"
                  style={{ color: BODY }}
                >
                  <p>
                    deepc connects the clinical systems your health system already
                    runs - EHR, PACS, reporting, claims, documents, and data infrastructure
                    - to the AI workflows your teams want to bring into routine care.
                  </p>
                  <p>
                    The architecture standardizes how AI capabilities are packaged,
                    deployed, monitored, and governed, so every new workflow can reuse
                    the same integration layer, runtime, and evidence trail.
                  </p>
                </div>
              </div>
              <div className="xl:col-span-7 max-w-4xl mx-auto w-full">
                <LayeredStackDiagram />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default InfrastructureArchitecture;
